export default [
  {
    path: "cockpitDashboard",
    name: "cockpitDashboard",
    meta: {
      title: "dashboard",
      keepAlive:true,
    },
    component: () =>
      import("@/views/Home/CockpitManage/CockpitDashboard/index.vue")
  },
  {
    path: "cockpitTarget",
    name: "cockpitTarget",
    meta: {
      title: "targetManagement"
    },
    component: () =>
      import("@/views/Home/CockpitManage/CockpitTarget/index.vue")
  },
  {
    path: "setTarget",
    name: "setTarget",
    meta: {
      title: "targetSetting"
    },
    component: () =>
      import("@/views/Home/CockpitManage/CockpitTarget/setTarget.vue")
  },
  {
    path: "cockpitPerformanceReview",
    name: "cockpitPerformanceReview",
    meta: {
      title: "performanceReview"
    },
    component: () =>
      import("@/views/Home/CockpitManage/CockpitPerformanceReview/index.vue")
  },
  {
    path: "cockpitBasicSettings",
    name: "cockpitBasicSettings",
    meta: {
      title: "basicSettings"
    },
    component: () =>
      import("@/views/Home/CockpitManage/CockpitBasicSettings/index.vue")
  },
];
